export default ['$timeout', ($timeout) => {
    const messageService = {};
    messageService.messages = [];
    messageService.show = false;

    messageService.success = function() {
        if (messageService.messages.length){
            messageService.alerttype = 'alert--success';
            messageService.push();
        }
    };

    messageService.failure = function() {
        if (messageService.messages.length){
            messageService.alerttype = 'alert--fail';
            messageService.push();
        }
    };

    messageService.push = function(){
        $timeout.cancel(messageService.cleartimer);
        $timeout(() => messageService.show = true);
        messageService.cleartimer = $timeout(() => messageService.clear(), 4000);
    };

    messageService.clear = function() {
        messageService.show = false;
        $timeout(() => messageService.messages = [], 300);
    };

    messageService.add = function(message) {
        if ( !messageService.messages.length ||
            (messageService.messages.length === 1 && messageService.messages[0] !== message) ) {
            messageService.messages.push(message);
        }
    };

    return messageService;
  }];


// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/message.service.js